/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo[_ngcontent-%COMP%]   a.app-name[_ngcontent-%COMP%]{font-size:.9em}.clickable[_ngcontent-%COMP%]{cursor:pointer}\n/*# sourceMappingURL=sidebar.component.css.map*/"];
export { styles as styles };
